import type { SVGProps } from 'react';

interface KitchenIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function KitchenIcon({ className, ...props }: KitchenIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="3.68 2.93 16.75 16.75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M19.1768 9C19.5908 9.00016 19.9268 9.33588 19.9268 9.75C19.9268 10.1641 19.5908 10.4998 19.1768 10.5H18.1768V15.8828L18.1729 16.0371C18.0949 17.5709 16.8648 18.8011 15.3311 18.8789L15.1768 18.8828H8L7.8457 18.8789C6.3118 18.8012 5.08185 17.5709 5.00391 16.0371L5 15.8828V10.5H4.17676C3.76254 10.5 3.42676 10.1642 3.42676 9.75C3.42676 9.33579 3.76254 9 4.17676 9H19.1768ZM6.5 15.8828C6.50025 16.711 7.17173 17.3828 8 17.3828H15.1768C16.0049 17.3827 16.6765 16.7109 16.6768 15.8828V10.5H6.5V15.8828ZM9.00781 4.25C9.42201 4.25 9.75778 4.58581 9.75781 5V7.0293C9.75764 7.44336 9.42192 7.7793 9.00781 7.7793C8.59386 7.77916 8.25804 7.44323 8.25781 7.0293V5C8.25784 4.5859 8.59373 4.25014 9.00781 4.25ZM11.5879 4.25C12.0021 4.25 12.3379 4.58581 12.3379 5V7.0293C12.3377 7.44336 12.002 7.7793 11.5879 7.7793C11.174 7.77911 10.8381 7.4432 10.8379 7.0293V5C10.8379 4.58593 11.1739 4.25019 11.5879 4.25ZM14.1143 4.25C14.5283 4.25022 14.8642 4.58594 14.8643 5L14.8633 7.0293C14.8631 7.44336 14.5274 7.7793 14.1133 7.7793C13.6995 7.77895 13.3645 7.4431 13.3643 7.0293V5C13.3643 4.58583 13.7001 4.25003 14.1143 4.25Z" fill="currentColor"/>
    </svg>
  );
}
